import { render, staticRenderFns } from "./CardLapsible_v2.vue?vue&type=template&id=57f7a032&"
import script from "./CardLapsible_v2.vue?vue&type=script&lang=ts&"
export * from "./CardLapsible_v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57f7a032')) {
      api.createRecord('57f7a032', component.options)
    } else {
      api.reload('57f7a032', component.options)
    }
    module.hot.accept("./CardLapsible_v2.vue?vue&type=template&id=57f7a032&", function () {
      api.rerender('57f7a032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/CardLapsible_v2.vue"
export default component.exports